import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentPen, faCommentPlus } from '@fortawesome/pro-light-svg-icons';
import { Tooltip } from '@mui/material';

interface AttendanceProtocolCommentProps {
  startComment?: string;
  endComment?: string;
  onClick: () => void;
  hasRegistration: boolean;
}

export function AttendanceProtocolComment(props: AttendanceProtocolCommentProps) {
  const { startComment, endComment, hasRegistration, onClick } = props;

  const hasComments = startComment || endComment;

  function getTitle() {
    if (!hasRegistration) {
      return 'Foretag registrering';
    }
    return hasComments ? 'Redigér kommentarer' : 'Tilføj kommentarer';
  }

  return (
    <Tooltip title={getTitle()}>
      <FontAwesomeIcon
        icon={hasComments ? faCommentPen : faCommentPlus}
        onClick={hasRegistration ? onClick : () => {}}
        cursor={hasRegistration ? 'pointer' : 'inherit'}
        color={hasRegistration ? 'inherit' : 'lightgray'}
      />
    </Tooltip>
  );
}
